// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"12840826","404":"3d163018","498":"d5e9eca8","513":"d9dc9e32","787":"e56be84f"}[chunkId] + ".chunk.js";
};